import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class';
import * as fieldComponents from '../../components/fields/artwork-link-selector-v1/artwork-link-selector-v1-index';

@Injectable({
    providedIn: 'root'
})
export class ArtworkLinkSelectorV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'artwork-link-selector-v1';
    menuTitle: string = "Artwork Link Selector";
    deprecated: boolean = false;
    /**
     * 
     * @param position the position of the new field to create
     * @returns an isntance of this field with the default data set and new uuid    v4
     */
    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsArtworkLinkSelectorV1Field(this.type, position);
    }

    /**
     * 
     * @param field the field data we got from database
     * @returns an isntance of this field with the data from database set
     */
    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        const f =  new fields.SettingsArtworkLinkSelectorV1Field(field.type, field.position);
        return f.deserialize(field);
    }

    getSettingsComponentType(): Type<fieldComponents.SettingsArtworkLinkSelectorV1FieldComponent> {
        return fieldComponents.SettingsArtworkLinkSelectorV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillArtworkLinkSelectorV1FieldComponent> {
        return fieldComponents.FillArtworkLinkSelectorV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewArtworkLinkSelectorV1FieldComponent> {
        return fieldComponents.ViewArtworkLinkSelectorV1FieldComponent;
    }


    /**
      * 
      * @param field the object data of the field
      * @returns ArtworkLinkSelectorV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.ArtworkLinkSelectorV1Field(this.type, field);
        // }
        // else {
            return new fields.SettingsArtworkLinkSelectorV1Field(this.type, 0);
        // }
    }
}

